<div class="epidemiology-view">
  <h1 class="epidemiology-title">{{ 'WEB_RESULTS.EPIDEMIOLOGY.VIEW_TITLE' | translate }}</h1>
  <div class="epidemiology-date-range" *ngIf="dateRangeLabel">{{ dateRangeLabel }}</div>

  <p-message *ngIf="error" severity="error" [text]="error"></p-message>

  <section class="epidemiology-section epidemiology-actions-bar" *ngIf="!loading">
    <p-button
      [label]="'WEB_RESULTS.EPIDEMIOLOGY.SENSITIVITY_ATB' | translate"
      icon="pi pi-table"
      (onClick)="openSensitivityAtbView()"
      [disabled]="!canOpenSensitivityAtb"
    ></p-button>
  </section>

  <section class="epidemiology-section" *ngIf="patient">
    <afoone-patient-data [patient]="patient"></afoone-patient-data>
  </section>

  <section class="epidemiology-section">
    <h2 class="epidemiology-section-label">{{ 'WEB_RESULTS.EPIDEMIOLOGY.TABLE_TITLE' | translate }}</h2>

    <div class="loading" *ngIf="loading">{{ 'WEB_RESULTS.EPIDEMIOLOGY.LOADING_DATA' | translate }}</div>

    <ng-container *ngIf="!loading">
      <p-table
        [value]="tableRowsModel"
        [paginator]="true"
        [rows]="tableRows"
        [rowsPerPageOptions]="tableRowsOptions"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}-{last} / {totalRecords}"
        styleClass="p-datatable-striped epidemiology-datatable"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th scope="col" pSortableColumn="requisNr">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_REQUIS_NR' | translate }}
              <p-sortIcon field="requisNr"></p-sortIcon>
            </th>
            <th scope="col" pSortableColumn="entryDateForFilter">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_ENTRY_DATE' | translate }}
              <p-sortIcon field="entryDateForFilter"></p-sortIcon>
              <p-columnFilter
                type="date"
                field="entryDateForFilter"
                display="menu"
                [showOperator]="false"
                [showAddButton]="false"
              ></p-columnFilter>
            </th>
            <th scope="col" pSortableColumn="materialName">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_SAMPLE_TYPE' | translate }}
              <p-sortIcon field="materialName"></p-sortIcon>
              <p-columnFilter type="text" field="materialName" display="menu" matchMode="contains" [showOperator]="false"></p-columnFilter>
            </th>
            <th scope="col" pSortableColumn="culture">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_CULTURE' | translate }}
              <p-sortIcon field="culture"></p-sortIcon>
              <p-columnFilter type="text" field="culture" display="menu" matchMode="contains" [showOperator]="false"></p-columnFilter>
            </th>
            <th scope="col" pSortableColumn="isolateDisplay">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_ISOLATE' | translate }}
              <p-sortIcon field="isolateDisplay"></p-sortIcon>
              <p-columnFilter type="text" field="isolateDisplay" display="menu" matchMode="contains" [showOperator]="false"></p-columnFilter>
            </th>
            <th scope="col" pSortableColumn="isolateNr">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_ISOLATE_NR' | translate }}
              <p-sortIcon field="isolateNr"></p-sortIcon>
            </th>
            <th scope="col" class="epi-atb-col" pSortableColumn="atbForFilter">
              {{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_ATB' | translate }}
              <p-sortIcon field="atbForFilter"></p-sortIcon>
              <p-columnFilter
                field="atbForFilter"
                matchMode="equals"
                display="menu"
                [showApplyButton]="false"
                [showOperator]="false"
                [showAddButton]="false"
                [showMatchModes]="false"
              >
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <fieldset class="atb-filter-options">
                    <legend class="sr-only">{{ 'WEB_RESULTS.EPIDEMIOLOGY.COL_ATB' | translate }}</legend>
                    <button
                      type="button"
                      class="atb-filter-option"
                      [class.atb-filter-option--active]="value == null"
                      (click)="onAtbFilterClear(filter)"
                    >
                      Todos
                    </button>
                    <button
                      type="button"
                      class="atb-filter-option"
                      [class.atb-filter-option--active]="value === true"
                      (click)="onAtbFilterChange(true, filter)"
                    >
                      {{ 'WEB_RESULTS.EPIDEMIOLOGY.ATB_YES' | translate }}
                    </button>
                    <button
                      type="button"
                      class="atb-filter-option"
                      [class.atb-filter-option--active]="value === false"
                      (click)="onAtbFilterChange(false, filter)"
                    >
                      {{ 'WEB_RESULTS.EPIDEMIOLOGY.ATB_NO' | translate }}
                    </button>
                  </fieldset>
                </ng-template>
              </p-columnFilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <button
                type="button"
                class="requis-link"
                (click)="openRequis(row)"
              >{{ row.requisNr }}</button>
            </td>
            <td>{{ row.formattedEntryDate }}</td>
            <td>{{ row.materialName }}</td>
            <td>{{ row.culture }}</td>
            <td>
              <span [pTooltip]="isolateDisplay(row)" tooltipPosition="top">{{ isolateDisplay(row) }}</span>
            </td>
            <td>{{ row.isolateNr }}</td>
            <td class="epi-atb-cell">
              <afoone-atb-pills-icon
                *ngIf="atbIsPositive(row)"
                class="atb-positive"
                [attr.aria-label]="'WEB_RESULTS.EPIDEMIOLOGY.ATB_YES' | translate"
              ></afoone-atb-pills-icon>
              <span class="sr-only">{{ (atbIsPositive(row) ? 'WEB_RESULTS.EPIDEMIOLOGY.ATB_YES' : 'WEB_RESULTS.EPIDEMIOLOGY.ATB_NO') | translate }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="7">{{ 'WEB_RESULTS.EPIDEMIOLOGY.EMPTY_TABLE' | translate }}</td></tr>
        </ng-template>
      </p-table>
    </ng-container>
  </section>
</div>
